import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Shield, Headphones, Clock, Globe } from 'lucide-react';
import appStoreIcons from '../Assets/Buttons.png';
import { CreditCard, Smartphone, DollarSign, Landmark } from 'lucide-react';
import visaLogo from '../Assets/visa.png';
import googlePayLogo from '../Assets/google-pay.png';
import paytmLogo from '../Assets/paytm.png';
import cashLogo from '../Assets/cash-on-delivery.png'
import { Link } from 'react-router-dom';
import logo1 from "../Assets/Untitled-1-removebg-preview.png"
import logo2 from "../Assets/Untitled-9.png"

const Footer = () => {

    
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              {/* <div className="w-10 h-10 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-xl font-bold">🚖</span>
              </div> */}
               <div className="flex items-center">
            <Link to="/" className="text-xl md:text-2xl font-bold text-blue-700">
              <span className="text-orange-500">Shree Puja</span>Travels
            </Link>
          </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Your trusted partner for safe, reliable, and affordable cab services across the country. 
              Book your ride in seconds and travel with confidence.
            </p>
            
            {/* Trust Badges */}
            <div className="flex flex-wrap gap-4 mb-6">
              <div className="flex items-center gap-2 bg-gray-800 px-3 py-2 rounded-lg">
                <Shield className="w-5 h-5 text-green-400" />
                <span className="text-sm">Safe & Secure</span>
              </div>
              <div className="flex items-center gap-2 bg-gray-800 px-3 py-2 rounded-lg">
                <Headphones className="w-5 h-5 text-cyan-400" />
                <span className="text-sm">24/7 Support</span>
              </div>
            </div>
            
            {/* Social Media */}
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors">Home</a>
              </li>
              <li>
                <a href="/contact" className="text-gray-400 hover:text-cyan-400 transition-colors">Book a Cab</a>
              </li>
              <li>
                <a href="/quick-booking" className="text-gray-400 hover:text-cyan-400 transition-colors">Airport Transfers</a>
              </li>
              <li>
                <a href="/quick-booking" className="text-gray-400 hover:text-cyan-400 transition-colors">Outstation Rides</a>
              </li>
              <li>
                <a href="/quick-booking" className="text-gray-400 hover:text-cyan-400 transition-colors">Local Rides</a>
              </li>
              <li>
                <a href="/quick-booking" className="text-gray-400 hover:text-cyan-400 transition-colors">City Tours</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors">Luxury Cabs</a>
              </li>
              <li>
                <a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors">SUV Rentals</a>
              </li>
              <li>
                <a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors">Wedding Cars</a>
              </li>
              <li>
                <a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors">Corporate Travel</a>
              </li>
              <li>
                <a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors">Event Transportation</a>
              </li>
              <li>
                <a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors">Monthly Packages</a>
              </li>
            </ul>
          </div>

          {/* Contact & Support */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Headphones className="w-5 h-5 text-cyan-400 mt-0.5" />
                <div>
                  <p className="text-gray-400">24/7 Customer Support</p>
                  <a href="tel:+919100390049" className="font-medium hover:text-cyan-400">+91  9100390049 </a><br/>
                  <a href="tel:+919100390049" className="font-medium hover:text-cyan-400">+91  9100390049</a>

                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-cyan-400 mt-0.5" />
                <div>
                  <p className="text-gray-400">Business Hours</p>
                  <p className="font-medium">Mon-Sun: 24/7</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Globe className="w-5 h-5 text-cyan-400 mt-0.5" />
                <div>
                  <p className="text-gray-400">Email</p>
                  <a href="mailto:shreepujatraveldesk@gmail.com" className="font-medium hover:text-cyan-400">shreepujatraveldesk@gmail.com</a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Download App Section */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div>
              <h3 className="text-lg font-bold mb-2">Download Our App</h3>
              <p className="text-gray-400">Book cabs faster with our mobile app</p>
            </div>
            <div className="flex flex-wrap gap-4">
  <a href="#" className="flex items-center gap-3  hover:bg-gray-700 px-6 py-3 rounded-lg transition-colors">
    <div className="">
      <img 
        src={appStoreIcons} 
        alt="App Store and Google Play" 
        className="w-full h-full object-contain"
      />
    </div>
    {/* <div>
      <p className="text-xs text-gray-400">Download our app</p>
      <p className="font-bold">Available Now</p>
    </div> */}
  </a>
</div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-gray-950 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-500 text-sm">
              © {new Date().getFullYear()} CabBooking. All rights reserved.
            </div>
            
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors">Terms of Service</a>
              <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors">Cookie Policy</a>
              <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors">Cancellation Policy</a>
              <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors">FAQ</a>
            </div>
            
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 text-sm">
    <span className="text-gray-400 whitespace-nowrap">Accepted Payments:</span>
    <div className="flex flex-wrap gap-2">
      {/* Card Payments */}
      <div className="flex items-center gap-1">
        <img src={visaLogo} alt="Visa" className="w-10 h-8 object-contain bg-white p-1 rounded shadow-sm" />
      </div>
      
      {/* UPI Payments */}
      <div className="flex items-center gap-1">
        <img src={googlePayLogo} alt="Google Pay" className="w-10 h-8 object-contain bg-white p-1 rounded shadow-sm" />
        <img src={paytmLogo} alt="Paytm" className="w-10 h-8 object-contain bg-white p-1 rounded shadow-sm" />
      </div>
      
      {/* Cash */}
      <img src={cashLogo} alt="Cash" className="w-10 h-8 object-contain bg-white p-1 rounded shadow-sm" />
    </div>
  </div>
          </div>
        </div>
      </div>


      <section className="bg-gray-950 text-gray-400 py-4">
  <div className="container mx-auto px-4">
    <div className="max-w-6xl mx-auto">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-sm">
        </div>
        
       <div className="text-sm gap-2 flex items-center">
  <span className="mr-1">Developed by</span>
  <a 
    href="https://freelancerx.in" 
    target="_blank" 
    rel="noopener noreferrer"
    className="text-gray-100 hover:text-gray-300 transition-colors font-medium flex items-center gap-1"
  >
    {/* FreelancerX Logo */}
    <div className="w-5 h-5 bg-gradient-to-r from-gray-100 to-gray-100 rounded flex items-center justify-center">
      <img src={logo1} alt="FreelancerX" className="w-4 h-4 object-contain" />
    </div>
    FreelancerX
  </a>
  {/* <span className="mx-1">&</span>
  <a 
    href="https://techtota.com" 
    target="_blank" 
    rel="noopener noreferrer"
    className="text-gray-100 hover:text-gray-300 transition-colors font-medium flex items-center gap-1"
  >
  
    <div className="w-5 h-5 bg-gradient-to-r from-gray-100 to-gray-100 rounded flex items-center justify-center">
      <img src={logo2} alt="Techtota" className="w-4 h-4 object-contain" />
    </div>
    Techtota
  </a> */}
</div>
        
        <div className="text-xs">
          {/* React • Tailwind CSS • TypeScript */}
        </div>
      </div>
    </div>
  </div>
</section>
    </footer>
  );
};

export default Footer;